import { render, staticRenderFns } from "./CreateRegionControl.vue?vue&type=template&id=8f1fe0c0&"
import script from "./CreateRegionControl.vue?vue&type=script&lang=js&"
export * from "./CreateRegionControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports